module.exports = __webpack_public_path__ + "media/components/assets/img/pic/smiling-bus-flyo-daab3bbac67f9fa6896332a7cdd90537.svg";